/** Jobreel Design System tokens — theme-aware.
 *  Every color is a CSS variable (defined in theme.css as RGB channels), so the
 *  whole app follows the active theme (light/dark) with no per-component change.
 *  Use withAlpha(color, a) instead of string-concatenating a hex opacity suffix. */

const c = (name: string) => `rgb(var(--${name}))`;

/** Apply alpha to a token color: withAlpha(T.teal, 0.5) → rgb(var(--teal) / 0.5).
 *  Works for any token value (static or a dynamically-picked one like scoreColor). */
export const withAlpha = (color: string, a: number) => color.replace(/\)\s*$/, ` / ${a})`);

export const T = {
  bg:   c("bg"),
  s1:   c("s1"),
  s2:   c("s2"),
  s3:   c("s3"),
  s4:   c("s4"),

  b0:   c("b0"),
  b1:   c("b1"),
  b2:   c("b2"),

  teal:     c("teal"),
  tealDim:  c("tealDim"),
  tealSoft: c("tealSoft"),
  tealBg:   c("tealBg"),
  tealBdr:  c("tealBdr"),
  tealGlow: `rgb(var(--teal) / 0.07)`,

  cta:    c("cta"),
  ctaHov: c("ctaHov"),
  ctaTxt: c("ctaTxt"),

  ok:      c("ok"),
  okBg:    c("okBg"),
  okBdr:   c("okBdr"),
  warn:    c("warn"),
  warnBg:  c("warnBg"),
  warnBdr: c("warnBdr"),
  mid:     c("mid"),
  midBg:   c("midBg"),
  err:     c("err"),
  errBg:   c("errBg"),
  errHov:  c("errHov"),
  errBdr:  c("errBdr"),
  info:    c("info"),
  infoBg:  c("infoBg"),
  infoBdr: c("infoBdr"),

  t0: c("t0"),
  t1: c("t1"),
  t2: c("t2"),
  t3: c("t3"),

  display: "'Sora', system-ui, sans-serif",
  body:    "'DM Sans', system-ui, sans-serif",
  mono:    "'JetBrains Mono', 'DM Mono', monospace",
} as const;

export const scoreColor = (s: number) =>
  s >= 85 ? T.ok : s >= 70 ? T.warn : s >= 50 ? T.mid : T.err;

export const scoreBg = (s: number) =>
  s >= 85 ? T.okBg : s >= 70 ? T.warnBg : s >= 50 ? T.midBg : T.errBg;
